/* @flow */
// typecheck: ignore file
import cx from 'classnames';
import AccountTransferDisabledModal from './AccountTransferDisabledModal.jsx';
import AddBankAccountModal from './AddBankAccountModal.jsx';
import IdentityVerificationModal from './IdentityVerificationModal.jsx';
import TransactionSettingsContainer from 'settings/containers/TransactionSettingsContainer.jsx';
import IdentityAdditionalVerificationModalContainer from 'payments/containers/IdentityAdditionalVerificationModalContainer.jsx';
import { mountModal } from 'lib/modal.js';
import PaymentAccountActions from './../actions/PaymentAccountActions';
import PaymentAccountStore from 'payments/stores/PaymentAccountStore';
import ConnectedBankAccountActions from 'payments/actions/ConnectedBankAccountActions';
import { showToast } from 'reducers/toasts';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CurrentUser from 'auth/CurrentUser';
import React from 'react';

const OPEN_INFORMATION = 'identity_modal';
const OPEN_BANKACCOUNT = 'bank_account_modal';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

function RequirePaymentData(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
  const onError = () => {
    replaceWith('/classes');
    callback();
  };

  const promises = [];

  if (CurrentUser.getUser().canCreateActivity()) {
    promises.push(ConnectedBankAccountActions.load());
  }

  if (PaymentAccountStore.getPaymentAccount()) {
    PaymentAccountActions.load(); // non-blocking refresh.
  } else {
    promises.push(PaymentAccountActions.load());
  }

  Promise.all(promises).then(
    () => callback(),
    () => onError(),
  );
}

type Props = {
  location: {
    query: Object,
  },
  className?: string,
  showToast: (text: string, kind: 'success' | 'error') => any,
};

class TransactionSettingsView extends React.Component {
  props: Props;

  static onEnter = RequirePaymentData;

  componentDidMount(): void {
    const account = PaymentAccountStore.getPaymentAccount();
    const show = this.props.location.query.show;

    if (show === OPEN_INFORMATION) {
      if (account.isTransferEnabled()) {
        this.props.showToast('Identify already verified.', 'success');
        return;
      }

      if (account.needBasicVerification()) {
        mountModal(<IdentityVerificationModal />, this);
      } else if (account.needAdditionalVerification()) {
        mountModal(<IdentityAdditionalVerificationModalContainer />, this);
      } else {
        mountModal(<AccountTransferDisabledModal />, this);
      }
    }

    if (show === OPEN_BANKACCOUNT) {
      if (account.needBankAccountVerification()) {
        mountModal(<AddBankAccountModal />, this);
      } else {
        this.props.showToast('Bank account already verified.', 'success');
      }
    }
  }

  render() {
    return (
      <div className={cx('TransactionSettingsView', this.props.className)}>
        <TransactionSettingsContainer />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ showToast }, dispatch);
}

export { TransactionSettingsView };
export default connect(undefined, mapDispatchToProps)(TransactionSettingsView);



// WEBPACK FOOTER //
// ./src/payments/components/TransactionSettingsView.jsx